import timezoneData from '@/data/predefined/timezone.json'

const regions = timezoneData.map(item => ({
  value: item.value,
  label: item.label,
}))

export default [
  {
    key: 'image',
    initKey: 'profilePicture',
    label: 'field.image',
    type: 'single-image',
    rules: 'size:10000',
    pw: 200,
    ph: 200,
    fullWidth: false,
    cols: 12,
  },
  {
    key: 'firstName',
    label: 'field.firstName',
    rules: 'required|max:50',
    type: 'text',
  },
  {
    key: 'lastName',
    label: 'field.lastName',
    rules: 'required|max:50',
    type: 'text',
  },
  {
    key: 'phone',
    label: 'field.phoneNumber',
    rules: 'required|min:9|max:10',
    type: 'tel',
    cols: 12,
  },
  {
    key: 'email',
    label: 'field.email',
    placeholder: 'placeholder.email',
    // rules: 'required|email|max:100|company_email',
    rules: 'required|email|max:100',
    type: 'text',
    cols: 12,
  },
  {
    key: 'origin',
    label: 'field.region',
    rules: 'required',
    type: 'single-selection',
    cols: 12,
    reduce: true,
    selectionKey: 'value',
    selectionLabel: 'label',
    options: regions,
  },
]
